import React from 'react';
import {AuthLogin} from '../actions'
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import arrow from "../build/images/icon_arrow_right.svg";
import { connection_platform } from '../services/api';

const mapDispatchToProps = dispatch => {
  return {
    onAddPost: post => {
      dispatch(AuthLogin(post));
    }
  };
};

const mapStateToProps = (state) => {
  return {
    VerificarUser: state.informationusers,
    VerificarReasons: state.reasonsblock
  };
}

class Senha extends React.Component {
  state = { password: '', changepassword: false};

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.onAddPost(this.state.password);
    this._inputSenha.focus();
  };

  handlePassword = e => {
    e.preventDefault();
    this.setState({changepassword: true});
  };

  render() {
    const {VerificarUser, VerificarReasons} = this.props;
    var msg = '';
    const box = [];

    if(this.state.changepassword){
      return <Redirect to='/changepassword' />
    }

    if (VerificarUser.displayname != undefined && VerificarUser.error === undefined && VerificarUser.error != true && VerificarReasons != 0){

      if(!VerificarUser.force_password_change){
        return <Redirect to='/dashboard' />;
      }
      
    }
      
   
    if(VerificarUser.error){
      box.push("is-invalid");
      msg= 'Senha incorreta'
    }

    if (VerificarUser.length === 0)
      return <Redirect to='/login' />;

    if(VerificarUser.hour){
      box.push("is-invalid");
      msg = 'Não é possível logar fora do seu horário de trabalho'
    }

    return (
      <div className="login">
      <div className={connection_platform.class_image_login}>
        {/* <h1>IngWeb</h1>
        <p>Otimizador de centros de atendimentos</p> */}
      </div>
      <div className="col-form">
        <div className="block no-round">
            <div className="block-content">
                <form onSubmit={ this.handleSubmit } name="form_login" className="row justify-content-md-center" id="form_login">
                  <div className="form-group">
                      <h2>Seja Bem-vindo!</h2>
                      <p>Entre com sua senha</p>
                  </div>
                  <div className="form-group">
                      <input className={box.join('' )} autoFocus={true} ref={c => (this._inputSenha = c)} value={ this.state.password } onChange={ this.handleInputChange } type="password" name="password" id="password" placeholder="Senha" />
                      <div className="invalid-feedback">{msg}</div>
                  </div>
                  <div className="form-group flex space-between">
                      <a id="forgot-password" className="inline">Esqueci minha senha</a>
                      <button type="submit" className="btn btn-primary btn-hero btn-small pull-right">Login <img alt="arrow" src={arrow} width="8" /></button>
                  </div>
                        <div className="form-group">
                          <a onClick={event => this.handlePassword(event, this)} id="change-password" className="btn btn-outline-primary btn-block change-password">Alterar Senha</a>
                       </div>
                </form>
            </div>
        </div>
      </div>
    </div>
    );
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Senha);